import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Chip from "@material-ui/core/Chip";

const useStyles = makeStyles({
  card: {
    marginBottom: 12,
  },
  cardContent: {
    paddingBottom: 12,
  },
  header: {
    marginBottom: 12,
    paddingBottom: 8,
    borderBottom: "2px solid #1d2d40",
  },
  assessmentName: {
    fontWeight: 600,
    fontSize: 15,
    color: "#1d2d40",
  },
  infoGrid: {
    marginTop: 8,
  },
  label: {
    fontSize: 12,
    color: "#666",
    marginBottom: 6,
  },
  value: {
    fontWeight: 600,
    fontSize: 18,
    color: "#333",
  },
  availableValue: {
    fontWeight: 600,
    fontSize: 18,
  },
});

interface InventoryCardProps { item: { name?: React.ReactNode; purchased: number; used: number }; }

export default function InventoryCard({ item }: InventoryCardProps): React.ReactElement {
  const classes = useStyles();
  const available = item.purchased - item.used;

  return (
    <Card className={classes.card} variant="outlined">
      <CardContent className={classes.cardContent}>
        <div className={classes.header}>
          <Typography className={classes.assessmentName}>
            {item.name}
          </Typography>
        </div>

        <Grid container spacing={2} className={classes.infoGrid}>
          <Grid item xs={4}>
            <Typography className={classes.label}>Purchased</Typography>
            <Typography className={classes.value} align="center">
              {item.purchased}
            </Typography>
          </Grid>

          <Grid item xs={4}>
            <Typography className={classes.label}>Used</Typography>
            <Typography className={classes.value} align="center">
              {item.used}
            </Typography>
          </Grid>

          <Grid item xs={4}>
            <Typography className={classes.label}>Available</Typography>
            <Typography
              className={classes.availableValue}
              align="center"
              style={{
                color: available > 0 ? "#03aab1" : "#b94946",
              }}
            >
              {available}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
